import { connect } from 'react-redux'
import IncomingCallDisplay from './IncomingCallDisplay'

const stateToProps = ({ numbers }, { node }) => ({
  number: numbers.numbersById[node.extras.numberSid],
  loading: numbers.numbersLoading,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(IncomingCallDisplay)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingCall/IncomingCallDisplay.container.js